/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./cityPageBoost.vue?vue&type=template&id=fd91455a"
import script from "./cityPageBoost.vue?vue&type=script&lang=js"
export * from "./cityPageBoost.vue?vue&type=script&lang=js"
import style0 from "./cityPageBoost.vue?vue&type=style&index=0&id=fd91455a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports